export default "__VITE_ASSET__fa3ebca1__"